import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import LeadKanbanBoard from "../../components/leads/LeadKanbanBoard";

export default function CollectionsBoard() {
  const { t } = useTranslation("leads");
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    // fill: true drops the layout's default page padding/header so the board
    // can own the full viewport height (below the h-16 sticky topbar).
    setInfo({
      name: t("Collections Board"),
      desc: t("Workflow collected and dropped off vehicles"),
      fill: true,
    });
  }, [t]);

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)] px-4 sm:px-6 md:px-4 pt-2">
      <div className="prose mb-2 flex-shrink-0">
        <h1 className="font-semibold text-gray-900 mb-0">{t("Collections Board")}</h1>
        <h4 className="text-base font-medium text-gray-500 mt-1">
          {t("Workflow collected and dropped off vehicles")}
        </h4>
      </div>
      <div className="flex-1 min-h-0">
        <LeadKanbanBoard max={25} fillHeight />
      </div>
    </div>
  );
}
